import { useIntl } from 'react-intl';

import { DownloadableCert } from '../DownloadableCert';

import { ReactComponent as Limitededition } from '@/assets/icons/Limitededition.svg';

import * as M from '../../messages';

export interface DownloadProps {
  channel: string;
  sn: string;
}
export const DownloadableLimitededition = ({ channel, sn }: DownloadProps) => {
  const { formatMessage } = useIntl();
  return (
    <DownloadableCert
      Svg={Limitededition}
      channel={channel}
      data-test-id='DownloadableLimitededition'
      fileName='limited'
      sn={sn}
      text={formatMessage(M.messages.limitedEditionCertificate)}
    />
  );
};

DownloadableLimitededition.displayName = 'DownloadableLimitededition';
